import type { TFunction } from 'i18next';

/** Shared by every paged profile-setup form so the three states read the same everywhere. */
export const submitLabel = (t: TFunction, disabled: boolean | undefined, isLastPage: boolean): string => {
  if (disabled) return t('community.onboard.submitting');
  if (isLastPage) return t('community.onboard.finish');
  return t('community.onboard.continue');
};
